<template>
  <div>
    <MenuCount_Storage/>
    <Count_list/>
  </div>
</template>

<script>
import MenuCount_Storage from "@/components/admin/stock/count_storage/menucount_storage/MenuCount_Storage";
import Count_list from "@/components/admin/stock/count_storage/Count_list";
export default {
  name: "CountListWareHouse",
  components: {
    Count_list,
    MenuCount_Storage
  }
}
</script>

<style scoped>

</style>
